import React from 'react';
import { UpdateLog } from '../types';

interface LogsViewerProps {
  logs: UpdateLog[];
}

const LogsViewer: React.FC<LogsViewerProps> = ({ logs }) => {
  return (
    <div className="FW-logs-panel">
      <h3>Процесс обновления</h3>
      <div className="FW-logs-container">
        {logs.length === 0 ? (
          <p className="FW-logs-empty">Ожидание запуска...</p>
        ) : (
          logs.map((log, i) => (
            <p key={i}>{JSON.stringify(log.message)}</p>
          ))
        )}
      </div>
    </div>
  );
};

export default LogsViewer;




